import { ContractType } from '@/pages/instruments/new-instrument/constants/contract-types'
import { Side } from '@/pages/instruments/new-instrument/constants/sides'
import {
  PrimaryTerminalLegParams,
  ScheduleGenerator,
  ScheduleLeg,
  Strike,
} from '@/pages/instruments/new-instrument/schedule-builders/types'

export type VanillaOptions = {
  strikes: Strike[]
  currency_id: number
  initial_observation_date: Date
  maturity_date: Date
  settlement_cycle: number
  contract_type: ContractType
  side: Side
}

const buildPrimaryLeg = (params: PrimaryTerminalLegParams<VanillaOptions>): ScheduleLeg => {
  const { strike, currency_id, contract_type, initial_observation_date, maturity_date, side } =
    params

  return {
    participation_rate: side === 'Long' ? 1 : -1,
    option_type: 'Vanilla',
    contract_type,
    region_type: 'European',
    currency_id,
    strike: strike.value,
    strike_percent: strike.percent,
    instrument_id: strike.underlying_id,
    initial_observation_date,
    pay_date: maturity_date,
    start_observation_date: maturity_date,
    end_observation_date: maturity_date,
  }
}

// const buildBarrierLeg = (params: BarrierLegParams<VanillaOptions>): ScheduleLeg => {
//   const {} = params

//   return {}
// }

export const VanillaGenerator: ScheduleGenerator<VanillaOptions> = {
  generate: ({ strikes, ...params }) => {
    const legs: ScheduleLeg[] = []

    for (const [index, strike] of strikes.entries()) {
      legs.push({ ...buildPrimaryLeg({ strike, ...params }), leg_id: index + 1 })
    }
    return legs
  },
}
